import type { MutableRefObject, WheelEvent } from 'react';

import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';
import { calculateMousePositions } from '../../../utils/calculate-mouse-positions.js';
import { MIN_ZOOM_STEP } from '../constants.js';
import type { InteractionTriggers, ZoomBehavior } from '../types.js';

export const temporaryZoom = ({
  event,
  lastMousePositionRef,
  width,
  onZoomChange,
}: {
  event: WheelEvent;
  width: number;
  lastMousePositionRef: MutableRefObject<RelativeAbsolutePosition | undefined>;
  onZoomChange?: (event: {
    triggeredBy: InteractionTriggers;
    deltaStart: number;
    deltaEnd: number;
    behavior: ZoomBehavior;
  }) => void;
}) => {
  const vertical = event.deltaY && event.deltaY !== 0;
  const wheelPosition = calculateMousePositions(event, event.currentTarget);
  lastMousePositionRef.current = wheelPosition;

  if (vertical) {
    const wheelUp = event.deltaY < 0;

    const delta = wheelUp
      ? Math.min(event.deltaY, -MIN_ZOOM_STEP)
      : Math.max(event.deltaY, MIN_ZOOM_STEP);

    const ratio = wheelPosition.relative.x / width;
    const deltaStart = -delta * ratio;
    const deltaEnd = delta * (1 - ratio);

    onZoomChange?.({
      triggeredBy: 'pointer',
      deltaStart,
      deltaEnd,
      behavior: wheelUp ? 'zoom-in' : 'zoom-out',
    });
  }
};
